// extracted by mini-css-extract-plugin
module.exports = {"component":"InfoView_component_3EnJb","content":"InfoView_content_2A9QU"};